<template>
	<MainLayout>
		<div class="container">
			<div class="box">
				<b-button class="float-right" @click="() => newSaleChannel()" >{{$t('saleChannel.new')}}</b-button>
				<h2>{{$t('saleChannel.saleChannel')}}</h2>
				<hr>
				<b-form @submit="(evt) => { evt.preventDefault(); this.$root.$emit('bv::refresh::table', 'sales-channel-index-list') } ">
					<div class="row">
						<b-form-group class="col-md-2" :label="$t('global.search')">
							<b-form-input v-model="filters.search" type="text" />
						</b-form-group>
						<b-form-group class="col" label=".">
							<b-button type="submit" variant="primary">{{$t('global.search')}}</b-button>
						</b-form-group>
					</div>
				</b-form>
				<AjaxTable
					id="sales-channel-index-list"
					:filters="filters"
					:columns="columns"
					resource="sales-channels"
					sortBy
					sortDesc
				>
					<template v-slot:cell(actions)="row">
						<div class="text-center">
							<b-button @click="$router.push('/sales-channel/'+row.item.id)" type="button" size="sm" class="mr-1" variant="success">
								<md-icon icon="info" />
							</b-button>
							<b-button @click="(event) => modelView(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="info">
								<md-icon icon="edit" />
							</b-button>
							<b-button @click="(event) => modelDelete(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="danger">
								<md-icon icon="delete" />
							</b-button>
						</div>
					</template>
				</AjaxTable>
			</div>
		</div>
		<Single ref="single" :success-callback="successCallback" />
	</MainLayout>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import AjaxTable from '../../helpers/AjaxTable.vue'
import Single from './Single.vue'

export default {
	components: { MainLayout, Single, AjaxTable },
	data(){
			return {
				modalInfo : {
					modelId:-1,
				},
				filters : {
					search:'',
				},
				columns : [
					{key:'id',label:'ID',sortable:true},
					{key:'name',label:this.$t('saleChannel.name'),sortable:true},
					{key:'code',label:this.$t('saleChannel.code')},
					{key:'status',label:this.$t('global.status')},
					{key:'description',label:this.$t('global.description')},
					{key:'actions',label:this.$t('global.actions')},
				],
				sortBy: 'id',
				sortDesc:true
			}
	},
	methods:{
		successCallback(){
			this.$root.$emit('bv::refresh::table', 'sales-channel-index-list')
		},
		modelView(item){
			this.$refs['single'].loadModel(item.id)
		},
		newSaleChannel(accessType){
			this.$refs['single'].loadModel(-1)
			if (accessType) {
				this.$refs['single'].setAccessType(accessType)
			}
		},
		modelDelete(item){
			this.$bvModal
			.msgBoxConfirm(this.$t("saleChannel.confirmDelete",{saleChannel:item.name}), {
				title: this.$t("warnings.okToContinue"),
				size: "md",
				buttonSize: "md",
				okVariant: "danger",
				okTitle: this.$t("global.yes")+", "+this.$t("warnings.continue"),
				cancelTitle: "Cancel",
				footerClass: "p-2",
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if (value === true) {
					this.$root.api.delete(`/sales-channels/${item.id}`).then(() => {
						this.$root.auxVars.loadResourcesOpts({vm: this,resourceNames: ["salesChannels"], forceRefresh: true});
						this.$root.showAlert(this.$t('global.registerDeleted'),{variant:'success'})
						this.successCallback();
						close()
					}).catch( err => {
						this.$root.handleRequestError(err)
						close()
					});
				}
			})
			.catch(err => {
				console.log(err);
				// An error occurred
			});
		}
	},
	mounted(){
	}
}
</script>

<style>

</style>
